import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { FeedPreview, NewsletterPreview, previewFor, audienceIcon } from './Previews';
const UNIT = {
  month: '/month',
  week: '/week',
  issue: '/issue',
  article: '/article',
  campaign: '/campaign',
  'one-off': ' one-off'
};

// No figures: what kind of campaign they have in mind (labels match the server's)
const BUDGETS = [['test', 'A test campaign'], ['monthly', 'An ongoing monthly campaign'], ['large', 'A large or multi-channel campaign']];
const AUDIENCES = [['all', 'Everyone on Voucha'], ['nigeria', 'Readers in Nigeria'], ['all-diaspora', 'Readers outside Nigeria'], ['canada', 'Readers in Canada'], ['us', 'Readers in the United States'], ['uk', 'Readers in the United Kingdom'], ['aspiring', 'People planning to move abroad']];
const emptyForm = () => ({
  company: '',
  name: '',
  email: '',
  phone: '',
  interest: '',
  budget: '',
  target: '',
  message: '',
  website: ''
});

/** "Title\nDescription\n\nTitle\nDescription" -> [{title, text}] */
export const blocks = text => String(text || '').split(/\n\s*\n/).map(b => b.trim().split('\n')).filter(b => b[0] && b[0].trim()).map(([title, ...rest]) => ({
  title: title.trim(),
  text: rest.join(' ').trim()
}));
const lines = text => String(text || '').split('\n').map(l => l.trim()).filter(Boolean);

/**
 * /advertise - the advertiser page. All wording, placements, packages and
 * prices come from the admin panel (Admin > Voucha Ads).
 */
export default class AdvertisePage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.error = false;
    this.form = emptyForm();
    this.sending = false;
    this.sent = false;
    this.formError = null;
    try {
      this.currency = localStorage.getItem('voucha-ads-currency') === 'NGN' ? 'NGN' : 'USD';
    } catch (e) {
      this.currency = 'USD';
    }
    app.setTitle('Advertise on Voucha');
    app.setTitleCount(0);
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/voucha-ads/page'
    }).then(data => {
      this.data = data;
    }).catch(() => {
      this.error = true;
    }).finally(() => {
      m.redraw();
      // Deep links such as /advertise#packages
      const hash = window.location.hash.slice(1);
      if (hash) setTimeout(() => this.scrollTo(hash), 50);
    });
  }

  // ---------- prices ----------

  money(usd) {
    if (this.currency === 'NGN') {
      const ngn = usd * this.data.rate.usdNgn;
      const rounded = ngn >= 10000 ? Math.round(ngn / 1000) * 1000 : Math.round(ngn / 100) * 100;
      return '₦' + rounded.toLocaleString('en-US');
    }
    return '$' + Math.round(usd).toLocaleString('en-US');
  }
  price(p) {
    const range = p.priceMax && p.priceMax > p.priceMin ? this.money(p.priceMin) + '–' + this.money(p.priceMax).replace(/^[$₦]/, '') : this.money(p.priceMin);
    return range + (UNIT[p.priceUnit] || '');
  }

  /** Page text with {usd:320} placeholders shown in the chosen currency */
  text(value) {
    return String(value || '').replace(/\{usd:(\d+(?:\.\d+)?)\}/g, (_, n) => this.money(parseFloat(n)));
  }
  setCurrency(currency) {
    this.currency = currency;
    try {
      localStorage.setItem('voucha-ads-currency', currency);
    } catch (e) {}
  }
  scrollTo(id) {
    const el = document.getElementById('advertise-' + id);
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  // ---------- view ----------

  view() {
    if (this.error) {
      return m("div", {
        className: "VouchaAdvertise container"
      }, m("p", null, "The advertiser page could not load. Please try again, or email advertise@thevoucha.com."));
    }
    if (!this.data) {
      return m("div", {
        className: "VouchaAdvertise container"
      }, m(LoadingIndicator, null));
    }
    const {
      copy
    } = this.data;
    const formats = blocks(copy.formats);
    const logos = lines(copy.logos).map(l => l.split('|').map(x => x.trim())).filter(([name, src]) => name && /^https?:\/\//.test(src || ''));
    return m("div", {
      className: "VouchaAdvertise container"
    }, this.hero(copy), this.data.stats && this.data.stats.length ? m("div", {
      className: "VouchaAdvertise-stats"
    }, this.data.stats.map(st => m("div", {
      className: "VouchaAdvertise-stat"
    }, m("strong", null, st.value), m("span", null, st.label), m("small", null, st.note)))) : null, m("section", {
      className: "VouchaAdvertise-section"
    }, m("h2", null, copy.audienceTitle), m("ul", {
      className: "VouchaAdvertise-audience"
    }, lines(copy.audience).map(item => m("li", null, m("span", {
      className: "VouchaAdvertise-audienceIcon",
      "aria-hidden": "true"
    }, m("i", {
      className: audienceIcon(item)
    })), m("span", null, item))))), formats.length ? m("section", {
      className: "VouchaAdvertise-section",
      id: "advertise-formats"
    }, m("h2", null, copy.formatsTitle), m("div", {
      className: "VouchaAdvertise-formats"
    }, formats.map(f => m("div", {
      className: "VouchaAdvertise-format has-preview"
    }, m("div", {
      className: "VouchaAdvertise-formatArt"
    }, m(previewFor(f.title))), m("h3", null, f.title), m("p", null, f.text), m("button", {
      type: "button",
      className: "VouchaAdvertise-link",
      onclick: () => {
        this.form.interest = f.title.slice(0, 60);
        this.scrollTo('enquire');
      }
    }, "Get in touch"))))) : null, logos.length || copy.testimonial ? m("section", {
      className: "VouchaAdvertise-section VouchaAdvertise-proof"
    }, logos.length ? m("h2", null, copy.proofTitle) : null, logos.length ? m("div", {
      className: "VouchaAdvertise-logos"
    }, logos.map(([name, src]) => m("img", {
      src: src,
      alt: name,
      title: name,
      loading: "lazy"
    }))) : null, copy.testimonial ? m("blockquote", {
      className: "VouchaAdvertise-quote"
    }, m("p", null, copy.testimonial), copy.testimonialBy ? m("cite", null, copy.testimonialBy) : null) : null) : null, m("section", {
      className: "VouchaAdvertise-section"
    }, m("h2", null, "Our standards"), lines(copy.rules).map(l => m("p", {
      className: "VouchaAdvertise-muted"
    }, l))), this.enquiryForm(copy, formats));
  }
  hero(copy) {
    return m("header", {
      className: "VouchaAdvertise-hero VouchaAdvertise-hero--split"
    }, m("div", {
      className: "VouchaAdvertise-heroText"
    }, m("div", {
      className: "VouchaAdvertise-kicker"
    }, "Voucha Advertising"), m("h1", null, copy.heroTitle), m("p", {
      className: "VouchaAdvertise-subtitle"
    }, copy.heroSubtitle), m("div", {
      className: "VouchaAdvertise-chips"
    }, lines(copy.highlights).map(h => m("span", {
      className: "VouchaAdvertise-chip"
    }, h))), m("div", {
      className: "VouchaAdvertise-heroActions"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.scrollTo('enquire')
    }, "Get in touch"), /^https?:\/\//.test(copy.mediaKitUrl || '') ? m("a", {
      className: "Button",
      href: copy.mediaKitUrl,
      target: "_blank",
      rel: "noopener"
    }, "Download the media kit") : null)), m("div", {
      className: "VouchaAdvertise-heroArt"
    }, m(FeedPreview, null), m("div", {
      className: "VouchaAdvertise-heroFloat"
    }, m(NewsletterPreview, null))));
  }
  details(text) {
    // "- " lines become a bullet list; other lines are paragraphs
    const out = [];
    let bullets = [];
    const flush = () => {
      if (bullets.length) out.push(m("ul", {
        className: "VouchaAdvertise-list"
      }, bullets));
      bullets = [];
    };
    lines(text).forEach(l => {
      if (l.startsWith('- ')) {
        bullets.push(m("li", null, this.text(l.slice(2))));
      } else {
        flush();
        out.push(m("p", {
          className: "VouchaAdvertise-muted"
        }, this.text(l)));
      }
    });
    flush();
    return out;
  }
  placementCard(p) {
    return m("div", {
      className: "VouchaAdvertise-card"
    }, m("div", {
      className: "VouchaAdvertise-cardHead"
    }, p.icon ? m("span", {
      className: "VouchaAdvertise-icon"
    }, p.icon) : null, m("div", null, m("h3", null, p.name, " ", p.badge ? m("span", {
      className: "VouchaAdvertise-badge"
    }, p.badge) : null), m("div", {
      className: "VouchaAdvertise-price"
    }, this.price(p)))), p.summary ? m("p", null, this.text(p.summary)) : null, p.details ? m("div", {
      className: "VouchaAdvertise-details"
    }, this.details(p.details)) : null);
  }
  packageCard(p) {
    return m("div", {
      className: 'VouchaAdvertise-card VouchaAdvertise-package' + (p.featured ? ' is-featured' : '')
    }, p.badge ? m("span", {
      className: "VouchaAdvertise-badge VouchaAdvertise-badge--top"
    }, p.badge) : null, m("h3", null, p.name), m("div", {
      className: "VouchaAdvertise-price VouchaAdvertise-price--big"
    }, this.price(p)), p.summary ? m("p", {
      className: "VouchaAdvertise-muted"
    }, this.text(p.summary)) : null, p.details ? m("div", {
      className: "VouchaAdvertise-details"
    }, this.details(p.details)) : null, m(Button, {
      className: 'Button ' + (p.featured ? 'Button--primary' : ''),
      onclick: () => this.choose(p.slug)
    }, "Request a proposal"));
  }
  choose(slug) {
    this.form.interest = slug;
    this.sent = false;
    this.scrollTo('enquire');
  }

  // ---------- enquiry form ----------

  enquiryForm(copy, formats) {
    const f = this.form;
    const field = (key, label, attrs = {}) => m("div", {
      className: "Form-group"
    }, m("label", {
      for: 'vads-' + key
    }, label), m("input", Object.assign({
      id: 'vads-' + key,
      className: "FormControl",
      value: f[key],
      oninput: e => f[key] = e.target.value
    }, attrs)));
    return m("section", {
      className: "VouchaAdvertise-section VouchaAdvertise-enquire",
      id: "advertise-enquire"
    }, m("h2", null, "Get in touch"), m("p", {
      className: "VouchaAdvertise-muted"
    }, this.text(copy.formIntro)), this.sent ? m("div", {
      className: "VouchaAdvertise-success"
    }, m("strong", null, "Thank you. We have received your enquiry."), m("p", null, "We will respond to ", f.email || 'you', " within one working day. A confirmation has been sent to your inbox."), m(Button, {
      className: "Button",
      onclick: () => {
        this.form = emptyForm();
        this.sent = false;
      }
    }, "Send another enquiry")) : m("form", {
      className: "VouchaAdvertise-form",
      onsubmit: e => {
        e.preventDefault();
        this.submit();
      }
    }, m("div", {
      className: "VouchaAdvertise-formGrid"
    }, field('company', 'Company *', {
      required: true,
      maxlength: 150,
      autocomplete: 'organization'
    }), field('name', 'Your name *', {
      required: true,
      maxlength: 150,
      autocomplete: 'name'
    }), field('email', 'Work email *', {
      required: true,
      type: 'email',
      maxlength: 191,
      autocomplete: 'email'
    }), field('phone', 'Phone', {
      type: 'tel',
      maxlength: 50,
      autocomplete: 'tel'
    }), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "vads-interest"
    }, "Interested in"), m("select", {
      id: "vads-interest",
      className: "FormControl",
      value: f.interest,
      onchange: e => f.interest = e.target.value
    }, m("option", {
      value: ""
    }, "Not sure yet"), formats.map(fm => m("option", {
      value: fm.title.slice(0, 60)
    }, fm.title)), m("option", {
      value: "custom"
    }, "Something else"))), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "vads-budget"
    }, "What kind of campaign?"), m("select", {
      id: "vads-budget",
      className: "FormControl",
      value: f.budget,
      onchange: e => f.budget = e.target.value
    }, m("option", {
      value: ""
    }, "Still deciding"), BUDGETS.map(([value, label]) => m("option", {
      value: value
    }, label)))), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "vads-target"
    }, "Who do you want to reach?"), m("select", {
      id: "vads-target",
      className: "FormControl",
      value: f.target,
      onchange: e => f.target = e.target.value
    }, m("option", {
      value: ""
    }, "Not sure yet"), AUDIENCES.map(([value, label]) => m("option", {
      value: value
    }, label))))), m("div", {
      className: "Form-group"
    }, m("label", {
      for: "vads-message"
    }, "Your goals"), m("textarea", {
      id: "vads-message",
      className: "FormControl",
      rows: "5",
      maxlength: "5000",
      placeholder: "What are you promoting, who to, and by when?",
      value: f.message,
      oninput: e => f.message = e.target.value
    })), m("div", {
      className: "VouchaAdvertise-hp",
      "aria-hidden": "true"
    }, m("label", {
      for: "vads-website"
    }, "Website"), m("input", {
      id: "vads-website",
      tabindex: "-1",
      autocomplete: "off",
      value: f.website,
      oninput: e => f.website = e.target.value
    })), window.VouchaTurnstile && !app.session.user ? m(window.VouchaTurnstile, {
      action: 'advertise',
      onToken: t => this.turnstile = t,
      bind: w => this.turnstileWidget = w
    }) : null, this.formError ? m("p", {
      className: "VouchaAdvertise-error"
    }, this.formError) : null, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.sending
    }, "Send enquiry"), m("p", {
      className: "VouchaAdvertise-muted VouchaAdvertise-small"
    }, "These details are used only to respond to your enquiry. You can also write to", ' ', m("a", {
      href: 'mailto:' + this.data.contactEmail
    }, this.data.contactEmail), ".")));
  }
  submit() {
    this.sending = true;
    this.formError = null;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/voucha-ads/enquiries',
      body: Object.assign({}, this.form, {
        turnstile: this.turnstile || ''
      }),
      errorHandler: () => {}
    }).then(() => {
      this.sent = true;
    }).catch(e => {
      if (this.turnstileWidget) this.turnstileWidget.reset(); // each check works once
      this.formError = e?.response?.message || 'Your enquiry could not be sent. Please try again, or email ' + this.data.contactEmail + '.';
    }).finally(() => {
      this.sending = false;
      m.redraw();
    });
  }
}
flarum.reg.add('voucha-ads', 'forum/components/AdvertisePage', AdvertisePage);